export default "/_next/static/chunks/fonts/FontAwesome5_Regular-c3146b3524e97475c094343e848a7370.ttf";